export interface ConnectionState {
    initialized: boolean;
    connected: boolean;
    apiConnected: boolean;
    servicesConnected: boolean;
    displayConnectedWarning: boolean;
    isReconnected: boolean;
}

export const initialState: ConnectionState = {
    initialized: false,
    connected: false,
    apiConnected: false,
    servicesConnected: false,
    displayConnectedWarning: false,
    isReconnected: false,
};



// WEBPACK FOOTER //
// ./src/store/ConnectionState.ts